<template>
    <div>
    <b-card-body v-if="!editar">
        <b-media no-body>
            <b-media-body class="ml-4">
                <div v-if="puedeModificarHeader" class="text-right" >
                    <b-button 
                        size="sm" 
                        variant="outline-secondary"
                        @click="editarHeader()">
                        <i class="fa fa-pencil fa-lg"></i>
                    </b-button>
                </div>
                <h5 class="mt-0">
                    {{ header.nombre }}
                </h5>
                <div v-html="header.descripcion"></div>
            </b-media-body>
        </b-media>
        </b-card-body>

                <!--  ========================== EDITAR MENU ================================ -->

        <b-card-body v-if="editar">
            <b-row>
                <b-col sm="12" lg="12">
                    <div role="group">
                        <label for="inputLive"><b>Nombre:</b></label>
                        <b-form-input id="inputLive"
                            v-model="headerTmp.nombre"
                            type="text"
                            placeholder="Enter your name">
                        </b-form-input>
                    </div>
                </b-col>
                <b-col sm="12" lg="12">&nbsp;</b-col>
                <b-col sm="12" lg="12">
                
                <quill-editor ref="myTextEditor"
                        v-model="headerTmp.descripcion"
                        :options="editorOption">
                </quill-editor>
                
                </b-col>
                <b-col sm="12" lg="12">&nbsp;</b-col>
                <b-col sm="6" lg="6">
                    <b-button 
                        variant="secondary"
                        @click="editar=false">
                        Cancelar
                    </b-button>
                </b-col>
                <b-col sm="6" lg="6" class="text-right">
                    <b-button 
                        variant="primary"
                        @click="guardarHeader()">
                        Guardar
                    </b-button>
                </b-col>
            </b-row>
        </b-card-body>
    </div>
</template>

<script>

import swal from 'sweetalert'
import axios from 'axios'
import { mapGetters } from "vuex";

    
export default {
  name: 'ItemHeader',
  props:["headerUp"],
  components: {},
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken",
      "permisos",
      "role"
    ]),
    puedeModificarHeader(){
            if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 125) >= 0 )
                return true;
            else
                return false;
    }
  },
  watch: {
      headerUp(){
          this.header = this.headerUp;
      },
      '$route'(to, from) {
        this.id = to.params.id;
      }
  },
  data: function () {
    return {
        id: this.$route.params.id,
        header: this.headerUp,
        headerTmp:{},
        subiendoImg: false,
        editar: false,
        progreso: 0,
        editorSettings: {
          modules: {
            imageDrop: true,
            imageResize: {}
          }
        },
        editorOption: {
          modules: {
            toolbar: [
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'font': [] }],
              ['bold', 'italic', 'underline', 'strike'],
              [{ 'align': [] }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              [{ 'script': 'sub' }, { 'script': 'super' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
              [{ 'direction': 'rtl' }],
              [{ 'color': [] }, { 'background': [] }],
              ['clean'],
              ['link']
            ]
          }
        }
    }
  },
  methods: {
    editarHeader(){
        let header = {};
        header.nombre = this.header.nombre;
        header.descripcion = this.header.descripcion;
        this.headerTmp = this.$_.clone(header);
        this.editar = true;
    },
    guardarHeader(){
        this.$emit('enviandoStart');
        let ruta = 'seccion';
        if( this.tipoItem === 'menu')
            ruta = 'menu/datos'
        axios.put(this.httpURL+'/comsocial/directorio/menu/'+this.id,
              {
                nombre:this.headerTmp.nombre,
                descripcion:this.headerTmp.descripcion
              },
              {headers: {token:this.sessionToken}})
          .then(res => {
                  this.header.nombre = res.data.menu.nombre;
                  this.header.descripcion = res.data.menu.descripcion;
              this.$emit('enviandoStop');
              this.editar = false;
              this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                        text: res.data.mensaje });
          })
          .catch(error => {
              this.$emit('enviandoStop');
              if(error.response){
                  //console.log(error.response);
                  this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                      text: error.response.data.mensaje });
              }else if( error.request){
                  this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                      text: 'No se pudo establecer una conexión al servidor.' });
              }
          });
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

div.show-image {
    position: relative;
    float:left;
    margin:5px;
}
div.show-image:hover img{
    opacity:0.5;
}

div.show-image:hover .edit{
    display: block;
}

.edit {
	padding-top: 0px;	
	padding-right: 0px;
	position: absolute;
	right: 1;
	top: 1;
	display: none;
}

div.show-image .progreso-img{
	padding-top: 0px;	
	padding-right: 0px;
	position: absolute;
    width: 100%;
	
	top: 50%;
	display: block;
}

</style>

<style>
  .quill-editor:not(.bubble) .ql-container,
  .quill-editor:not(.bubble) .ql-container .ql-editor {
    height: 10rem;
    padding-bottom: 1rem;
  }
</style>

<style lang="scss" scoped>
